import * as React from 'react';
import Animated, { useAnimatedStyle, } from 'react-native-reanimated';
import { View } from 'react-native';
import { rem } from 'design-system/values';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const StoryProgress = ({ index, progressSharedValue, currentIndexSharedValue, containerStyle, }) => {
    const styles = useStyles(styleSet);
    const progressStyles = useAnimatedStyle(() => {
        if (currentIndexSharedValue.value === index) {
            return {
                width: `${progressSharedValue.value * 100}%`,
            };
        }
        if (currentIndexSharedValue.value > index) {
            return {
                width: '100%',
            };
        }
        return {
            width: 0,
        };
    });
    return (<View style={[styles.container, containerStyle]}>
      <Animated.View style={[styles.progressBar, progressStyles]}/>
    </View>);
};
export default StoryProgress;
const styleSet = createStyleSheets((colors) => ({
    container: {
        flex: 1,
        height: rem(4),
        overflow: 'hidden',
        borderRadius: rem(14),
        marginHorizontal: rem(4),
        backgroundColor: colors.cards.transparentOnDark,
    },
    progressBar: {
        height: rem(4),
        borderRadius: rem(14),
        backgroundColor: colors.buttons.brand,
    },
}));
